/**
 * Full SSR (treatment) entry for the train-lora route. Mounted via
 * `dynamicWithExperiment` from `routes/_app.train-lora.tsx`
 * whenever the global `SSR_DUAL_MODE_EXPERIMENT_NAME` experiment
 * resolves to `treatment`.
 *
 * Mirrors the previous inline `default` Component:
 * - Provides a route-scoped empty Apollo client so hooks like
 *   `useMe` / `useTrainLoraLayoutV2Experiment` can mount during SSR
 *   without throwing "Could not find 'client' in the context".
 * - Renders the real `TrainLoraPage` tree directly so the SSR HTML
 *   ships the hero / dataset form / FAQ landmarks needed for SEO.
 *
 * The CSR (control) entry lives in `_app.train-lora.csr.tsx` and
 * relies on the global `RootRuntime` Apollo client.
 */
import { ApolloProvider } from '@apollo/client/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { useMemo } from 'react'
import { Component as TrainLoraPage } from 'src/pages/TrainLoraPage'
import { createRouteApolloClient } from 'src/services/apollo/route-ssr-client'
import { useRequestContext } from 'src/utils/request-context'

export default function TrainLoraFullSSREntry() {
  const { queryClient } = useRequestContext()
  const apolloClient = useMemo(() => createRouteApolloClient([]), [])

  return (
    <QueryClientProvider client={queryClient}>
      <ApolloProvider client={apolloClient}>
        <TrainLoraPage />
      </ApolloProvider>
    </QueryClientProvider>
  )
}
